import styled from 'styled-components'

const StyledAdminView = styled.div`
  background-color: ${({ theme }) => theme.color.gray[100]};
  min-height: 100vh;

  form {
    max-width: 600px;
    margin: 0 auto;
    padding: 60px;
    box-sizing: border-box;
    display: grid;
    grid-gap: 20px;

    input, button {
      height: 38px;
      padding: 0 12px;
      border: 1px solid ${({ theme }) => theme.color.gray[300]};
      background-color: ${({ theme }) => theme.color.background};
      color: ${({ theme }) => theme.color.gray[900]};
      border-radius: 4px;
      transition: 0.2s;

      &::placeholder {
        color: ${({ theme }) => theme.color.gray[300]};
      }
    }

    button {
      height: 40px;
      font-weight: 500;
      color: ${({ theme }) => theme.color.background};
      border: 1px solid ${({ theme }) => theme.color.blue[700]};
      background-color: ${({ theme }) => theme.color.blue[600]};

      &:hover {
        cursor: pointer;
        background-color: ${({ theme }) => theme.color.blue[700]};
      }

      &:disabled {
        cursor: not-allowed;
        color: ${({ theme }) => theme.color.gray[400]};
        border: 1px solid ${({ theme }) => theme.color.gray[200]};
        background-color: ${({ theme }) => theme.color.gray[200]};
      }
    }
  }
`

export default StyledAdminView
